import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@linaria/react';
import config from '../../../content/meta/meta-config';
import avatarCherry from '../../images/avatar/avatar-cherry.jpg';
import avatarJames from '../../images/avatar/avatar-james.jpg';

const Author = (props) => {
  const { author, note, theme } = props;
  const avatar = author && author === '松鼠哥🐿️' ? avatarJames : avatarCherry;
  return (
    <React.Fragment>
      <AuthorStyled theme={theme}>
        <AvatarStyled>
          <img src={config.gravatarImgMd5 == '' ? avatar : config.gravatarImgMd5} alt={config.siteTitle} />
        </AvatarStyled>
        <NoteStyled theme={theme} dangerouslySetInnerHTML={{ __html: note }} />
      </AuthorStyled>
    </React.Fragment>
  );
};

Author.propTypes = {
  author: PropTypes.string,
  note: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired,
};

export default Author;

const AuthorStyled = styled.div`
  margin: ${(props) => props.theme.space.m} ${(props) => props.theme.space.l};
  padding: ${(props) => props.theme.space.l} 0;
  border-top: 1px solid ${(props) => props.theme.line.color};
  border-bottom: 1px solid ${(props) => props.theme.line.color};

  @media (min-width: 768px) {
    display: flex;
    align-items: center;
  }

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    padding: 30px 0;
  }
`;

const AvatarStyled = styled.div`
  border-radius: 65% 75%;
  display: inline-block;
  height: 50px;
  margin: 0 20px 0 0;
  overflow: hidden;
  width: 50px;

  img {
    width: 100%;
  }

  @media (min-width: 768px) {
    flex: 0 0 auto;
  }

  @media (max-width: 768px) {
    float: unset;
    display: unset;
    align-self: center;
    margin-bottom: 20px;
  }
`;

const NoteStyled = styled.div`
  font-size: 0.9em;
  line-height: ${(props) => props.theme.font.lineHeight.xxl};
`;
